// 需要提供48小时内核酸证明

const arr = [
  1192,
  1639,
  3437,
  6116,
  9073,
];

export default arr;
